import React from 'react';
import { NavigationContext } from '../../context/NavigationContext';

// Define the props type
interface NavigationComponentProps {
    navPath: string;
    children: React.ReactNode;
    matchType?: 'startsWith' | 'exact';
}

const NavigationComponent: React.FC<NavigationComponentProps> = ({ navPath, children, matchType = 'startsWith' }) => {
    const navigationContext = React.useContext(NavigationContext);

    if (!navigationContext) {
        throw new Error('NavigationComponent must be used within a NavigationProvider');
    }

    const { path } = navigationContext;

    // Determine if the current path matches based on matchType
    let shouldRender = false;
    
    switch (matchType) {
        case 'startsWith':
            shouldRender = path.startsWith(navPath);
            break;
        case 'exact':
            shouldRender = path === navPath;
            break;
        default:
            shouldRender = path.startsWith(navPath);
            break;
    }

    // Render children only if the current path matches the navPath
    if (!shouldRender) {
        return null;
    }

    return <>{children}</>;
};

export default NavigationComponent;